import _ from 'underscore';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, claimViewModel) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        var claimVm = claimViewModel();
        $scope.fnol.collisionTypeCodes = _.filter(claimVm.lossCause.aspects.availableValues, function (typeCode) {
            // for purposes of portal 'otherobjcoll' is not a collision code
            var nonCollisionAutoCodes = ['theftentire', 'glassbreakage', 'theftparts', 'otherobjcoll'];
            return nonCollisionAutoCodes.indexOf(typeCode.code) === -1;
        });
    };

    ctrl.isCollision = function (lossCause) {
        return _.findWhere($scope.fnol.collisionTypeCodes, {
            value: lossCause
        });
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/pa/controllers/PABaseFnolWizardCtrl.js
// module id = 1577
// module chunks = 0